import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
// import { getData } from '../../../Services';

const Show = () => {
  const auth = useSelector((state) => state.auth);
  const user = auth.user;

  // const dispatch = useDispatch();
  // const  proposal_service = getData({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr-enabled-proposal'});
  // useEffect(() => {
  //   proposal_service.then(rslt => {
  //     let qprEnabled = {qprEnabled: rslt.data.proposal};
  //     localStorage.setItem("proposal", JSON.stringify(qprEnabled));
  //     dispatch(proposalActions.qprEnabled(qprEnabled));
  //   });
  // }, []);
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>
                  Profile 
                  <Link to={"/user/profile/edit"} className="ml-2">
                    <FontAwesomeIcon icon={faEdit} title="Edit profile" />
                  </Link>
                </h5>
              </div>
              <div className='mt-4'>
                <div className='card border-info' style={{"borderTop": "3px solid"}}>
                  <div className='card-body'>
                    <table className='table table-borderless'>
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td>:</td>
                          <td>{user.fullname}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>:</td>
                          <td>{user.username}</td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td>:</td>
                          <td>{user.phone}</td>
                        </tr>
                        <tr>
                          <td>Gender</td>
                          <td>:</td>
                          <td>{user.gender}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Show;